import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  id: string;
};

export const getNewsDetail = createQueryFn(
  QueryNameSpace.getNewsDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.getNewsDetail(params.id);

    return res;
  },
);
